import React, { useState } from 'react'
import PropTypes from 'prop-types'
import cs from 'classnames'
import Glyph from '../glyph'
import Heading from '../heading'

import styles from './section.module.css'
import { Message } from '@paypalcorp/worldready-react'

const readMoreLinkText = (
  <Message id="common.components.section.readmore.button.text" />
)

const Section = ({
  defaultExpand = false,
  heading,
  body = '',
  children,
  disableShowMore = false,
  ...rest
}) => {
  if ((body.length || children.length) < 100) {
    disableShowMore = true
  }
  const [shouldShowMore, setShouldShowMore] = useState(disableShowMore)

  const [expanded, setExpanded] = useState(defaultExpand)

  return (
    <div className={styles.sectionContainer} {...rest}>
      <div
        className={styles.headingContainer}
        onClick={() => setExpanded((expandedState) => !expandedState)}
      >
        <Glyph icon={`icon-arrow-${expanded ? 'down' : 'right'}-half-small`} />
        <Heading text={heading} Element="h5" />
      </div>
      {expanded && (body || children) && (
        <>
          <div
            className={cs(
              styles.body,
              shouldShowMore ? styles.bodyShowMore : styles.bodyShowLess,
            )}
          >
            {body || children}
          </div>
          {!shouldShowMore && (
            <div
              className={styles.readMoreClickableSectionContainer}
              onClick={() =>
                setShouldShowMore((shouldShowMoreState) => !shouldShowMoreState)
              }
            >
              <span className={styles.readMoreText}>{readMoreLinkText}</span>
            </div>
          )}
        </>
      )}
    </div>
  )
}

Section.propTypes = {
  defaultExpand: PropTypes.bool,
  heading: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
  body: PropTypes.string,
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node,
  ]).isRequired,
  disableShowMore: PropTypes.bool,
}

export default Section
